module.exports = __webpack_public_path__ + "img/img_aiplan_02.07d66ffd.png";